// Version : 0.0.1
// Author : SABARI
import { makeApiCall } from '../../_common/api.utils';
import { API_URL } from '../../const';
/*************** ROLE DETAILS ADD START *************** */
export const roleDetailsAdd = (addData: any) => {
	const data = {
		AddRoleDetailsToken: addData,
	};
	const url = `${API_URL}addRoleDetails`;
	return makeApiCall(url, data);
};
/*************** ROLE DETAILS ADD END *************** */

/*************** ROLE DETAILS UPDATE START *************** */
export const roleDetailsUpdate = (updateData: any) => {
	const data = {
		UpdateRoleDetailsToken: updateData,
	};
	const url = `${API_URL}updateRoleDetails`;
	return makeApiCall(url, data);
};
/*************** ROLE DETAILS UPDATE END *************** */

/*************** ROLE DETAILS GET START *************** */
export const roleListGet = (listData: any) => {
	const data = {
		GetRoleListToken: listData,
	};
	const url = `${API_URL}getRoleList`;
	return makeApiCall(url, data);
};
/*************** ROLE DETAILS GET END *************** */

/*************** ROLE DETAILS FETCH START *************** */
export const roleDetailsFetch = (fetchData: any) => {
	const data = {
		FetchRoleDetailsToken: fetchData,
	};
	const url = `${API_URL}fetchRoleDetails`;
	return makeApiCall(url, data);
};
/*************** ROLE DETAILS FETCH END *************** */

/*************** ROLE DETAILS DELETE START *************** */
export const roleDetailsDelete = (deleteData: any) => {
	const data = {
		DeleteRoleDetailsToken: deleteData,
	};
	const url = `${API_URL}deleteRoleDetails`;
	return makeApiCall(url, data);
};
/*************** ROLE DETAILS DELETE END *************** */
